import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  ApiBaseUrl,
  askQuestionFromPdfApi,
  deleteProjectFileApi,
} from "../utils/Constants";

export const deletefile = createAsyncThunk("deletefile", async (payload) => {
  try {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: token },
    };

    const response = await axios.post(
      ApiBaseUrl + deleteProjectFileApi,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});

const DeleteFileSlice = createSlice({
  name: "DeleteFileReducer",

  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearDeleteFile: (state) => {
      state.data = null;
      state.isAuthenticated = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deletefile.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deletefile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(deletefile.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const { clearDeleteFile } = DeleteFileSlice.actions;
export default DeleteFileSlice.reducer;
